import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { subscriptionActive } from "../../api/handleapi";
import { setUpdateSubscriptionInfo } from "../../feature/showSlice/updateSubscriptionSlice";

export const useSubscription = (firebaseUseruid) => {
  const dispatch = useDispatch();

  const cached = JSON.parse(localStorage.getItem("subscriptionInfo") || "null");

  const [subscriptionInfo, setSubscriptionInfo] = useState(cached);
  const [loading, setLoading] = useState(!cached);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!firebaseUseruid) {
      setLoading(false);
      setSubscriptionInfo(null);
      return;
    }

    const fetchSubscription = async () => {
      try {
        setLoading(true);
        

        const getSubscriptionActive = await subscriptionActive(firebaseUseruid);

        dispatch(setUpdateSubscriptionInfo(getSubscriptionActive));

        localStorage.setItem(
          "subscriptionInfo",
          JSON.stringify(getSubscriptionActive)
        );

        setSubscriptionInfo(getSubscriptionActive);
      } catch (err) {
        console.error("Error obteniendo la suscripción:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [firebaseUseruid, dispatch]);

  return { subscriptionInfo, loading, error };
};
